import React, { Component } from 'react';

import './logoArea.css';
class LogoArea extends Component {
    
    render() { 
        return ( 
            <div className="logo-area mt-3">
                <span className="pl-2 d-inline-block">Groovvy</span>
            </div>  
         );
    }
}
 
export default LogoArea;